import styles from './header.module.css';
import React from 'react';

const Header = (props) => (
        <h1 className={styles.header}>Lotto Raffle</h1>
    );

export default Header;